import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PropType } from 'vue';

const __default__ = {
  name: 'MarkExtension'
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  editorId: {
    type: String as PropType<string>,
    default: ''
  }
},
  emits: ['onChange'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const markHandler = () => {
  // 获取输入框
  const textarea = document.querySelector(
    `#${props.editorId}-textarea`
  ) as HTMLTextAreaElement;
  // 获取选中的内容
  const selection = window.getSelection()?.toString();
  // 获取鼠标位置
  const endPoint = textarea.selectionStart;
  // 生成标记文本
  const markStr = `@${selection}@`;
  // 根据鼠标位置分割旧文本
  // 前半部分
  const prefixStr = textarea.value.substring(0, endPoint);
  // 后半部分
  const suffixStr = textarea.value.substring(endPoint + (selection?.length || 0));
  emit('onChange', `${prefixStr}${markStr}${suffixStr}`);
  setTimeout(() => {
    textarea.setSelectionRange(endPoint, markStr.length + endPoint);
    textarea.focus();
  }, 0);
};

return (_ctx: any,_cache: any) => {
  const _component_normal_toolbar = _resolveComponent("normal-toolbar")!

  return (_openBlock(), _createBlock(_component_normal_toolbar, {
    title: "mark",
    onOnClick: markHandler
  }, {
    trigger: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        class: "md-icon",
        "aria-hidden": "true"
      }, [
        _createElementVNode("use", { "xlink:href": "#icon-mark" })
      ], -1)
    ]))]),
    _: 1
  }))
}
}

})